import { countDownHandler } from "@/utils/global";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";

const OfferTimeCountDown = ({ counter }) => {
  const { t } = useTranslation("common");
  const [countDown, setCountDown] = useState(
    countDownHandler(counter?.["date-to"])
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setCountDown(countDownHandler(counter?.["date-to"]));
    }, 1000);

    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  return (
    countDown.isCountDown && (
      <p className="flex items-center justify-center w-full text-red-600">
        {t("Ends in")}{" "}
        <span>
          <bdi>
            {countDown.weeks} :{" "}
            {countDown.days} :{" "}
            {handleTwoDigit(countDown.hours)} :{" "}
            {handleTwoDigit(countDown.minutes)} :{" "}
            {handleTwoDigit(countDown.seconds)}
          </bdi>
        </span>
      </p>
    )
  );
};

export default OfferTimeCountDown;

const handleTwoDigit = (num) => {
  return num.toString().length === 1 ? `0${num}` : num;
};
